export const additionalChargesTab = {
  loading: "Carregando configurações…",
  tax: {
    title: "Imposto (IVA)",
    tag: "Incluído no preço",
    description:
      "O IVA já está <b>incluído</b> nos preços das suas tarifas. Aqui você só define qual porcentagem é discriminada no recibo e na fatura — <b>ele não é somado ao total</b>.",
    hint: "Vazio = é usado o IVA do emissor de faturamento atribuído. Aplica-se somente a reservas diretas.",
  },
  cleaning: {
    title: "Taxa de limpeza",
    tag: "Fixo",
    description: "Valor fixo por estadia. Se for <b>0</b>, não é aplicado.",
    showToGuest: "Mostrar no resumo da reserva",
  },
  charges: {
    title: "Cobranças adicionais",
    summary: "{count} cobrança configurada. | {count} cobranças configuradas.",
    summaryEmpty: "Crie cobranças opcionais (por reserva, por pessoa ou por noite).",
    addButton: "Adicionar cobrança",
    empty: "Nenhuma cobrança adicional ainda.",
    headers: {
      title: "Título",
      method: "Como é cobrado",
      value: "Valor",
      visible: "Visível",
    },
    titlePlaceholder: "ex.: Taxa turística",
    removeTitle: "Excluir",
    hint: "As cobranças visíveis são mostradas em uma linha separada para o hóspede no checkout; as demais são somadas ao total.",
  },
  methods: {
    perStay: "Valor por reserva",
    perNight: "Valor por noite",
    perPerson: "Valor por pessoa",
    perPersonPerNight: "Valor por pessoa por noite",
    percent: "% do total da reserva",
  },
  validation: {
    cleaningInvalid: "A taxa de limpeza deve ser um número válido e positivo.",
    taxRange: "O IVA deve estar entre 0 e 100%.",
    chargeTitleRequired: "Cada cobrança adicional precisa de um título.",
    chargeValueInvalid: 'O valor da cobrança "{title}" não é válido.',
    chargePercentMax: 'A porcentagem da cobrança "{title}" não pode ultrapassar 100%.',
  },
  toasts: {
    saveSuccess: "Cobranças adicionais salvas com sucesso.",
    saveError: "Não foi possível salvar as cobranças adicionais.",
  },
};